import { render } from "./DatosMenorSimple.vue?vue&type=template&id=5e6f03a2&ts=true"
import script from "./DatosMenorSimple.vue?vue&type=script&lang=ts"
export * from "./DatosMenorSimple.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__